export default __webpack_public_path__ + "6dd5c8f73d48b6897324beba9c55c5d9.svg";